// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__-BfUP","word":"Rating_word__LO9BE","formClose":"Rating_formClose__WW3x5","caption":"Rating_caption__85zdG","text":"Rating_text__DZRhU"};